import { TableBody, TableCell, TableRow } from "@mui/material";
import { transformDate } from "../../helpers";
import { VersionActionCell } from "../VersionActionCell";
import { VersionRefCell } from "../VersionRefCell";
import { StorageObjectValue } from "../../../../services/api/instances/storageApi/types/service_types";
import { StorageObjectVersion } from "../../../../services/api/instances/storageApi/types/object_types";
import styles from "./styles.module.css";

interface Props<T extends StorageObjectValue> {
  versions: StorageObjectVersion<T>[];
  onOk: (id: string) => void;
}

export const VersionsTableBody = <T extends StorageObjectValue>(
  props: Props<T>,
) => {
  return (
    <TableBody>
      {props.versions.map((version) => (
        <>
          <TableRow
            key={version.version_date}
            className={styles["table-body-row"]}
          >
            <TableCell>
              {transformDate(version?.version_date as string, "ru-RU")}
            </TableCell>
            <TableCell>{version.version_name}</TableCell>
            <VersionRefCell
              versionRef={version.ref!}
              id={version?.version_id!}
            />
            <VersionActionCell
              id={version?.version_id as string}
              name={version?.version_name as string}
              onOk={() => props.onOk(version?.version_id as string)}
            />
          </TableRow>
        </>
      ))}
    </TableBody>
  );
};
